import styled from "styled-components";

export const StyledPage = styled.div`
  display: flex;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;
